import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import BackToTop from '@/components/feature/BackToTop';
import useSeo from '@/hooks/useSeo';
import { faqs } from '@/mocks/faqs';
import HeroSection from './components/HeroSection';
import FeaturedTopics from './components/FeaturedTopics';
import CategoryGrid from './components/CategoryGrid';
import HotAndLatest from './components/HotAndLatest';
import FaqSection from './components/FaqSection';
import SubscribeSection from './components/SubscribeSection';

const SITE_URL = typeof window !== 'undefined' ? window.location.origin : '';

const HOME_JSONLD = [
  {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '看料社',
    alternateName: '在线看料资源库',
    url: SITE_URL,
    potentialAction: {
      '@type': 'SearchAction',
      target: {
        '@type': 'EntryPoint',
        urlTemplate: `${SITE_URL}/library?q={search_term_string}`,
      },
      'query-input': 'required name=search_term_string',
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '看料社',
    url: SITE_URL,
    email: 'contact@kanliaoshe.cn',
    description: '专注热门爆料与网络热点深度整理的中文专题资源库。',
  },
  {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((f) => ({
      '@type': 'Question',
      name: f.question,
      acceptedAnswer: { '@type': 'Answer', text: f.answer },
    })),
  },
];

export default function Home() {
  useSeo({
    title: '看料社 - 在线看料资源库全集完整版｜热门爆料专题合集',
    description:
      '看料社是在线看料资源库，提供在线看料全集完整版与系列专题合集。热门爆料事件深度整理，合集持续更新，想看哪部点哪部，一站式看料体验。',
    keywords: '在线看料,在线看料资源库,在线看料全集,在线看料完整版,在线看料系列,在线看料专题',
    type: 'website',
    jsonLd: HOME_JSONLD,
  });

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <HeroSection />
        <FeaturedTopics />
        <CategoryGrid />
        <HotAndLatest />
        <FaqSection />
        <SubscribeSection />
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
}